import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";
import useAnalytics from "hooks/useAnalytics";

import { VariableCellComponentProps } from "./types";

const DescriptionCell = ({ variable }: VariableCellComponentProps) => {
  const trackAnalytics = useAnalytics();

  const handleShowFullDescription = () => {
    trackAnalytics("Show full description clicked");
  };

  if (!variable.description) {
    return null;
  }

  return (
    <ListEntitiesItemDescriptionMultipleLines
      lines={1}
      hasChevronLink
      description={variable.description}
      onShowFullDescription={handleShowFullDescription}
    />
  );
};

export default DescriptionCell;
